import React from "react";

const safetyPoints = [
  "Profile verification",
  "Block & report",
  "Privacy-first messaging",
];

function SafetySection() {
  return (
    <section id="safety" className="section-neutral py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-sm uppercase tracking-[0.3em] text-purple-500 font-semibold">
              Safety
            </p>
            <h2 className="heading-primary text-3xl sm:text-4xl font-bold text-gray-900 mt-3">
              Trust, safety, and respect
            </h2>
            <p className="text-lg text-subtle mt-4">
              Your experience is protected with proactive moderation tools and
              privacy-first design.
            </p>
          </div>
          <div className="card-hover rounded-3xl bg-gradient-to-br from-purple-50 via-white to-pink-50 border border-purple-100 p-6 sm:p-8 shadow-sm">
            <ul className="space-y-4">
              {safetyPoints.map((point) => (
                <li key={point} className="flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-purple-600 text-white flex items-center justify-center font-semibold">
                    ✓
                  </span>
                  <span className="text-gray-700 text-lg font-medium">
                    {point}
                  </span>
                </li>
              ))}
            </ul>
            <div className="mt-6 text-sm text-gray-500">
              We use industry-standard encryption and always put your privacy
              first.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SafetySection;
